import {QRCodeSVG} from "qrcode.react";
import { ScanLine} from "lucide-react";

const DesktopView = () => {
    return (
        <div style={{
            backgroundImage: `url(${import.meta.env.VITE_VMS_BANNER_IMAGE})`,
            backgroundSize: '100% 50%',
            backgroundPosition: 'top',
            objectFit: 'cover',
            imageRendering: 'crisp-edges',
            backgroundRepeat: 'no-repeat'
        }} className="flex flex-col items-center justify-center h-screen bg-gray-100">
            <div className="flex flex-col w-[680px] px-8 items-center justify-center text-center p-8 border  border-[#153420]  bg-white bg-opacity-80 rounded-3xl shadow-md">
                <ScanLine size={30}/>
                <h1 className="text-2xl font-bold mt-6 mb-2">Scanner ce QR Code avec votre téléphone
                    pour accéder à l’application</h1>
                <p className="text-[#494848]">Cette application est uniquement disponible sur mobile.</p>

                <div className="flex flex-col items-center my-6">
                    {/*<p className="text-gray-600 mb-2">Scannez ce code QR avec votre téléphone pour ouvrir
                        l'application</p>*/}
                    <div className="p-6 bg-white rounded-3xl">
                        <QRCodeSVG
                            value={import.meta.env.VITE_VMS_OG_URL}
                            size={300}
                            level={"H"}
                            imageSettings={{
                                src: import.meta.env.VITE_VMS_FAVICON,
                                x: undefined,
                                y: undefined,
                                height: 40,
                                width: 40,
                                excavate: true,
                            }}
                        />
                    </div>
                </div>
                <div className='w-36 bg-[#CBCBCB] h-[1px] mb-6'/>
                <p className="text-sm text-gray-500">Ouvrez directement cette page sur votre téléphone</p>
            </div>
{/*
            <MousePointer className=' size-24 absolute translate-x-[12rem] translate-y-[12rem]'/>
*/}
            <div className='fixed bottom-2'>
                {import.meta.env.MODE === "development" && (
                    <p className='text-base text-red-500'>Version de demo 0.0.1</p>)}
                <a href='https://semoa-group.com/' target='_blank' className="flex h-8 text-third justify-center items-center gap-2">
                    <p className='text-xs text-gray-700'>Powered by</p>
                    <img className='size-12 object-contain' src='/Semoa.png' alt='Semoa'/>
                </a>
            </div>
        </div>
    );
};

export default DesktopView;
